import React, { useState, useEffect } from "react";
import Link from "next/link";
import { useCart } from "../services/hooks/useCart";
import currency from "currency.js";

const RecommendedProductCard = React.memo(({ product, onShowProductModal }) => {
  const [isOnSale, setIsOnSale] = useState(false);
  const [isInStock, setIsInStock] = useState(true);

  const { addToCart, removeFromCart, isInCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();

    addToCart({
      product,
      quantity: 1,
    });
  };

  const handleRemoveFromCart = (e) => {
    e.preventDefault();

    removeFromCart({
      productId: product.id,
    });
  };

  useEffect(() => {
    if (product) {
      setIsOnSale(
        product.compareAtPrice && product.price < product.compareAtPrice
      );

      setIsInStock(
        product.inventory.quantity > 0 ||
          product.inventory.policy === "continue"
      );
    }
  }, [product]);

  return (
    <div className="col-6 col-sm-6 col-md-4 col-lg-3">
      {/* Card */}
      <div className="card mb-7">
        {/* Badge */}
        {/* {isOnSale && isInStock && (
          <div className="badge badge-dark card-badge card-badge-left text-uppercase">
            Member pricing
          </div>
        )} */}

        {!isInStock && (
          <div className="badge badge-danger card-badge card-badge-left text-uppercase">
            Sold out
          </div>
        )}

        {/* Image */}
        <div className="card-img">
          {/* Image */}
          <Link href={`/products/${product.handle || product.id}`}>
            <a className="card-img-hover">
              <img
                className="card-img-top card-img-back"
                src={product.images[0].src}
                alt={product.name}
              />
              <img
                className="card-img-top card-img-front"
                src={product.images[0].src}
                alt={product.name}
              />
            </a>
          </Link>

          {/* Actions */}
          <div className="card-actions">
            <span className="card-action">
              <button
                className="btn btn-xs btn-circle btn-white-primary"
                data-toggle="tooltip"
                title="Quick view"
                onClick={() => onShowProductModal(product)}
              >
                <i className="fe fe-eye" />
              </button>
            </span>

            {isInStock &&
              (isInCart(product.id) ? (
                <span className="card-action">
                  <button
                    className="btn btn-xs btn-circle btn-white-primary"
                    data-toggle="button"
                    onClick={handleRemoveFromCart}
                  >
                    <i className="far fa-window-close" />
                  </button>
                </span>
              ) : (
                <span className="card-action">
                  <button
                    className="btn btn-xs btn-circle btn-white-primary"
                    data-toggle="button"
                    onClick={handleAddToCart}
                  >
                    <i className="fe fe-shopping-cart" />
                  </button>
                </span>
              ))}
          </div>
        </div>
        {/* Body */}
        <div className="card-body px-0">
          {/* Brand */}
          <div className="font-size-xs text-muted text-uppercase">
            {product.brand}
          </div>
          {/* Title */}
          <div className="font-weight-bold">
            <Link href={`/products/${product.handle || product.id}`}>
              <a className="text-body">{product.name}</a>
            </Link>
          </div>
          {/* Price */}
          {isOnSale ? (
            <div className="font-weight-bold text-muted">
              <span className="font-size-xs text-gray-350 text-decoration-line-through">
                {currency(product.compareAtPrice).format()}
              </span>
              <span className="text-primary">
                {currency(product.price).format()}
              </span>
            </div>
          ) : (
            <div className="font-weight-bold text-muted">
              {currency(product.price).format()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default RecommendedProductCard;
